import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@mui/material';

// 5 ago 2026 (Augusto: "quizás cuando sean 2, se puede hacer un pop up
// para preguntar si es recurrente dado que se repitió el mes pasado" —
// eligió la opción de UN SOLO diálogo con la lista completa, en vez de un
// pop-up por cada coincidencia): diálogo compartido entre
// TransactionsPage.js (alta manual) y StatementImporter.js (revisión de
// import). Recibe los candidatos ya detectados (ver
// utils/recurringDetection.js) y devuelve, al confirmar, cuáles quedaron
// marcados -- todos vienen pre-seleccionados porque ya pasaron el filtro
// de "proveedor + monto parecido + ~1 mes de diferencia", así que lo más
// común va a ser confirmar tal cual.
const fechaCorta = (fecha) => {
  if (!fecha) return '';
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-PE', { day: '2-digit', month: 'short' });
};

const RecurringCandidatesDialog = ({ open, candidatos, onConfirm, onCancel, isSpanish = true }) => {
  const [seleccion, setSeleccion] = useState({});

  useEffect(() => {
    if (open) {
      const inicial = {};
      (candidatos || []).forEach((_, i) => { inicial[i] = true; });
      setSeleccion(inicial);
    }
  }, [open, candidatos]);

  const toggle = (i) => setSeleccion((prev) => ({ ...prev, [i]: !prev[i] }));

  const confirmar = () => {
    const elegidos = (candidatos || []).filter((_, i) => seleccion[i]);
    onConfirm(elegidos);
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isSpanish ? '¿Alguno de estos es recurrente?' : 'Is any of these recurring?'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {isSpanish
            ? 'Estos proveedores también aparecieron hace un mes con un monto similar. Marca los que se repiten todos los meses.'
            : 'These providers also showed up about a month ago with a similar amount. Check the ones that repeat every month.'}
        </Typography>
        <List dense>
          {(candidatos || []).map((c, i) => (
            <ListItem key={i} disableGutters>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Checkbox edge="start" checked={!!seleccion[i]} onChange={() => toggle(i)} />
              </ListItemIcon>
              <ListItemText
                primary={`${c.nueva.proveedor} — S/ ${Number(c.nueva.monto).toFixed(2)}`}
                secondary={
                  isSpanish
                    ? `${fechaCorta(c.anterior.fecha)} y ${fechaCorta(c.nueva.fecha)}`
                    : `${fechaCorta(c.anterior.fecha)} and ${fechaCorta(c.nueva.fecha)}`
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{isSpanish ? 'Ninguno es recurrente' : 'None are recurring'}</Button>
        <Button variant="contained" onClick={confirmar}>
          {isSpanish ? 'Marcar seleccionados como recurrentes' : 'Mark selected as recurring'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecurringCandidatesDialog;
